// extracted by mini-css-extract-plugin
export default {"topBar":"Card_topBar__tAoQi","titleBlock":"Card_titleBlock__iKjP2"};